// extracted by mini-css-extract-plugin
module.exports = {"root":"stories_root__2VNzf","free":"stories_free__2qY1t","loaded":"stories_loaded__12Zt7"};